import React, { useState } from "react";
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom';
import { 
    AppBar,
    Box,
    Toolbar,
    Typography,
    Button,
    IconButton,
    Menu,
    MenuItem,
    Slide,
    Modal,
 } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

// import SVGLogo from "../../images/logo3.svg";
import PNGLogo from "../../images/perleto v3 logo.png";

import { Link } from "react-router-dom";

import LoginActions from "../LoginActions";

import "./navBar.css";


const pages = [
    {name:"Home", address:"/ "},
    // {name: "My competencies", address: "/mycompetencies"},
    {name: "Nanocompetencies", address: "/nanocompetencies"},
    {name: "My Studies", address: "/mystudies"},
];

const settings = ["Log in", "Log out", "Profile", "Account", "Dashboard", "Privacy"];

const NavBar = props => {

  const auth = props;
  
    // const {auth} = props;
    // console.log(auth)
    const [anchor, setAnchor] = useState(null);
    const [icon, setIcon] = useState("menu");
    const [anchorEl, setAnchorEl] = useState(null);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    const [selected, setSelected] = useState(-1);

    const openMenu = (event) => {
        setAnchor(event.currentTarget);
        setIcon("close");
    };
    
    const closeMenu = () => {
        setAnchor(null);
        setIcon("menu");
    };

    const onMenuItemClick = (event, index) => {
        setAnchor(null);
        setSelected(index);
        setIcon("menu");
    };
// console.log(auth)



    return (
    <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" className="app-bar" color="inherit">
          <Toolbar>
          {auth.auth.uid && (
            <>
            {/* <IconButton
              size="large"
              edge="start"
              onClick={openMenu}
              sx={{ mr: 2, position: "absolute" }}
            >
            {icon == "menu" ? (
                <MenuIcon />
            ):(
                <CloseIcon />
            )}

            </IconButton> */}
          
            {/* <Menu
                id="account-menu"
                open={Boolean(anchor)}
                onClose={closeMenu}
                anchorEl={anchor}
                keepMounted
                PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                    translate: 'scaleX(-1)',
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    left: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                > */}
                      {/* {console.log(pages)} */}

                    {/* {pages.map((page, index) => (
                    <MenuItem
                        key={index}
                        onClick={(page) => onMenuItemClick(page, index)}
                        selected= {index === selected}
                    >
                        <Link to={page.address} style={{ textDecoration: "none", color: "#000", width: "100%", height: "100%"}}>
                            {page.name}
                        </Link>
                    </MenuItem>
                    ))} */}

                {/* </Menu> */}
                </>
          )}
            <img src={PNGLogo} alt="header-logo" className="header-logo" style={{ width: "160px" }} />
            <LoginActions />
         

          </Toolbar>
        </AppBar>
      </Box>
    );
};

const mapStateToProps = ({auth, firebase}) => {
  return {
    auth: firebase.auth,
    authError: auth.authError
  }
}

export default connect(mapStateToProps)(NavBar)

